import { env } from './env';

const AppEnv = () => {
	// Deployed portals must call their own origin: on a custom domain the refresh
	// cookie is scoped to that host, and any other API host drops it as third-party.
	env.baseUrl =
		(window as any).env?.BASE_URL ||
		process.env.BASE_URL ||
		`${window.location.origin}/admin-portal`;

	env.baseDescopeUrl =
		(window as any).env?.BASE_DESCOPE_URL ||
		process.env.BASE_DESCOPE_URL ||
		window.location.origin;

	env.baseRoute = (window as any).env?.PUBLIC_PATH || process.env.PUBLIC_PATH;
	env.envName = (window as any).env?.ENV;

	const rawBaseStaticUrl =
		(window as any).env?.STATIC_BASE_URL || process.env.STATIC_BASE_URL;
	env.baseStaticUrl = (rawBaseStaticUrl || '/pages').startsWith('/')
		? window.location.origin + rawBaseStaticUrl
		: rawBaseStaticUrl;

	return null;
};

export default AppEnv;
